var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(true),expression:"true"}],staticClass:"loading-overlay",attrs:{"element-loading-text":_vm.text,"element-loading-spinner":"el-icon-loading","element-loading-background":"rgba(0, 0, 0, 0.2)"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }